//引入vue
import Vue from 'vue';
//引入vue-router
import VueRouter from 'vue-router';
//第三方库需要use一下才能用
Vue.use(VueRouter)
//引用page1页面
import invite  from '../../../page/invite.vue';
//引用page2页面
import back  from '../../../page/return.vue';


//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}

//定义routes路由的集合，数组类型
const routes=[
    //单个路由均为对象类型，path代表的是路径，component代表组件
    {path:'/invite',component:invite},
    {path:"/back",component:back},
    //写个路径为空的路由
    {path:"",component:invite}    
]

//实例化VueRouter并将routes添加进去
const router=new VueRouter({
//ES6简写，等于routes：routes
    routes,
});

//抛出这个这个实例对象方便外部读取以及访问
export default router





// WEBPACK FOOTER //
// ./src/view/pc/router/index.js